export const LOGIN_SUCCESS = 'loginSuccess';
export const CREATE_PROFILE = 'createProfile';
export const DELETE_PROFILE = 'deleteProfile';
export const EDIT_PROFILE = 'editProfile';
export const GET_PROFILES = 'getProfiles';
export const SET_SELECT_PROFILE = 'setSelectProfile';
export const GET_SELECT_PROFILE = 'getSelectProfile';
export const SAVE_PROFILE_AGE_RATING = 'saveProfileAgeRating';
export const SAVE_PROFILE_NAME = 'saveProfileName';
export const UPDATE_PROFILES = 'updateProfiles';
